import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import type { SheetGeometry } from "building-types/views/sheetGeometryTypes";
import { docEntityHandleHash } from "doc/entity/core/handleHash";
import { isDocEntityHandle } from "doc/entity/docEntityHandleTools";
import type { Categorized3DGeometry } from "doc/plans/planGeometrySourceTypes";

export function getDocEntityHandlesFromGeometry(geometry: SheetGeometry | Categorized3DGeometry): DocEntityHandle[] {
  const handles: DocEntityHandle[] = [];
  const buildingEntityHandle = geometry.buildingEntity?.docEntityHandle;
  if (isDocEntityHandle(buildingEntityHandle)) {
    handles.push(buildingEntityHandle);
  }

  const geometryHandle = geometry.handle;
  if (
    geometryHandle &&
    !handles.some((handle) => docEntityHandleHash(handle) === docEntityHandleHash(geometryHandle))
  ) {
    handles.push(geometryHandle);
  }

  return handles;
}
